import React, {Component} from 'react';
import '../../styles/Home.css'

export default class RealizacjaTPayFailMiesieczne extends Component {

    render() {
        return <div className="rezerwacjaPomyslnie" id='divToPrint' style={{border: 'none'}}>
            <h2><i className="fa fa-2x fa-times" style={{color: 'red', marginRight: 25}}> </i>Wystąpił błąd</h2>
            <h5 style={{fontWeight: 400}}>Podczas dokonywania płatności wystąpił błąd. <a
                href={sessionStorage.getItem('platnosc').toString()}>Spróbuj ponownie.</a></h5>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/koszyk/finalizacja/RealizacjaTPayFailMiesieczne.js